import { Link, useLocation } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { SiteHeader } from "../../components/site/SiteHeader";
import { MaskedLine, FadeIn } from "../../components/motion/Reveal";
import { CONTACT } from "../../data/content";

const COPY = {
  enquiry: { title: "Enquiry received.", text: "Thank you — the NexSecure team will review your requirement and reach out shortly. For anything urgent, call us directly." },
  quote: { title: "Quote request received.", text: "Your requirement is with our engineering team. We'll review the details and documents, and respond with next steps." },
  application: { title: "Application received.", text: "Thank you for your interest in NexSecure. Our team reviews every application and responds within five working days." },
  "service-request": { title: "Service request received.", text: "Your request is logged. Our support team will diagnose and respond — remotely where possible, on-site where needed." },
};

export default function ThankYou() {
  const { search } = useLocation();
  const type = new URLSearchParams(search).get("type") || "enquiry";
  const copy = COPY[type] || COPY.enquiry;

  return (
    <div className="font-publicsans bg-nx-navy text-slate-200 antialiased min-h-screen flex flex-col" data-testid="thank-you-page">
      <SiteHeader />
      <section className="flex-1 flex items-center pt-24 pb-20 lg:pt-32 lg:pb-24">
        <div className="nx-wrap max-w-2xl text-center mx-auto">
          <FadeIn delay={0.2}>
            <CheckCircle2 size={56} className="text-nx-goldlight mx-auto mb-8" strokeWidth={1.2} />
          </FadeIn>
          <h1 className="font-marcellus text-4xl sm:text-5xl text-white" data-testid="thank-you-title">
            <MaskedLine delay={0.3}>{copy.title}</MaskedLine>
          </h1>
          <FadeIn delay={0.6}>
            <p className="mt-6 text-base md:text-lg text-slate-400 leading-relaxed">{copy.text}</p>
            <p className="mt-4 text-sm text-slate-500">Customer care: {CONTACT.phone} · {CONTACT.phone2} · {CONTACT.hours}</p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/solutions" data-testid="thank-you-solutions" className="inline-flex items-center justify-center border border-white/25 hover:border-nx-goldlight/70 text-white text-sm tracking-wide px-8 py-4 transition-colors">Explore Solutions</Link>
              <Link to="/" data-testid="thank-you-home" className="inline-flex items-center justify-center bg-nx-gold hover:bg-nx-goldlight text-nx-navy font-semibold text-sm tracking-wide px-8 py-4 transition-colors">Back to Home</Link>
            </div>
          </FadeIn>
        </div>
      </section>
    </div>
  );
}
